import { hexToRgb } from '@website/common/utils'

export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark,
    cardBackground: p => p.tertiaryDark,
    cardBackgroundGradient: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.5)`,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.2)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight,
    cardBackground: p => p.accentWhite,
    cardBackgroundGradient: p => `rgba(${hexToRgb(p.tertiaryLight)}, 0.4)`,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    cardBackground: p => p.accentWhite,
    cardBackgroundGradient: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 0.4)`,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`
  }
}
